import { render, staticRenderFns } from "./DocumentTemplateEditor.vue?vue&type=template&id=268dadd8"
import script from "./DocumentTemplateEditor.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports